export enum ActiveSearchSurgeryType {
  I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE = 'I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE',
  SURGERY_ALREADY_DONE = 'SURGERY_ALREADY_DONE',
  SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL = 'SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL',
  I_NO_LONGER_WISH_TO_CONTINUE = 'I_NO_LONGER_WISH_TO_CONTINUE',
  OPERATOR_AUTHORIZED = 'OPERATOR_AUTHORIZED',
  HOSPITAL_RETURN = 'HOSPITAL_RETURN',
  CHANGE_OF_DOCTOR = 'CHANGE_OF_DOCTOR',
  HEALTH_PLAN_ANOTHER_HOSPITAL = 'HEALTH_PLAN_ANOTHER_HOSPITAL',
  PERSONAL_PROBLEM = 'PERSONAL_PROBLEM',
  OTHER = 'OTHER',
  ALL = 'ALL'
}

export enum ActiveSearchSurgeryTranslated {
  I_DID_NOT_HAVE_SURGERY_BUT_I_WANT_TO_CONTINUE = 'Não realizei a cirurgia ainda, mas quero continuar o processo',
  SURGERY_ALREADY_DONE = 'Cirurgia já foi realizada em outra unidade da Rede',
  SURGERY_ALREADY_DONE_IN_OTHER_HOSPITAL = 'Cirurgia já foi realizada em outro hospital e pode ser cancelada',
  I_NO_LONGER_WISH_TO_CONTINUE = 'Não desejo mais realizar a cirurgia',
  OPERATOR_AUTHORIZED = 'Desisti por problemas de autorização da minha operadora',
  HOSPITAL_RETURN = 'Desisti por problemas de retorno do hospital',
  CHANGE_OF_DOCTOR = 'Troquei de médico dentro da Rede Mater Dei de Saúde',
  HEALTH_PLAN_ANOTHER_HOSPITAL = 'Meu plano de saúde me direcionou para outro hospital',
  PERSONAL_PROBLEM = 'Desisti por problemas pessoais',
  OTHER = 'Outras opções',
  ALL = 'Todos os motivos'
}
